export default __webpack_public_path__ + "static/media/favicon.2197d42b.ico";